import React, { useContext } from 'react';
import classnames from 'classnames';
import { OverlayContextProvider } from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay/OverlayContext';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';
import { BiLoggerContextProvider } from '@wix/da-shared-react/pkg/biLogger';
import { Strip as StripType } from '../../../types/api';
import { Pages } from '../../../constants';
import MoreDeviationsBySearch from './MoreDeviationsBySearch';
import Strip from './Strip';

import s from './Strips.scss';

export interface Props {
  strips?: StripType[];
  mainContentUrl?: string;
  page: Pages;
  originalSearchTerm?: string;
  /** Are these strips displayed at the very top of the homepage */
  areTopStrips?: boolean;
}

export const Strips: React.FC<Props> = ({
  page,
  originalSearchTerm,
  strips,
  mainContentUrl,
  areTopStrips,
}) => {
  const searchTerm = `'${originalSearchTerm}'`;
  const isMobile = useContext(MobileContext);
  const isSearchPage = page === Pages.Search;

  if (strips) {
    strips = strips.filter(
      strip =>
        strip.deviations ||
        strip.collections ||
        strip.groups ||
        strip.users ||
        strip.topNecos ||
        strip.tags
    );
  }

  if (!strips || strips.length === 0) {
    return null;
  }
  // if we're searching on mobile, expand the strip width to the outside of the viewport
  // so that cards in the strip slider on the right and left can always be seen
  let sliderClassName, sliderContentClassName;
  if (isMobile && isSearchPage) {
    sliderClassName = s['full-width-strips'];
    sliderContentClassName = s['full-width-strip-content'];
  }

  return (
    <div
      className={classnames(
        s['strips'],
        isSearchPage && s['on-search-page'],
        areTopStrips && s['top-strips']
      )}
    >
      <OverlayContextProvider
        value={{
          showDailyDeviationLabel: false,
          showSuggestedReasonLabel: false,
          showExtraActions: false,
        }}
      >
        {strips.map((strip, index) => (
          <BiLoggerContextProvider
            key={strip.title}
            value={{ sectionrank: index }}
          >
            <Strip
              strip={strip}
              page={page}
              className={s['strip']}
              sliderClassName={sliderClassName}
              sliderContentClassName={sliderContentClassName}
              isTopStrip={areTopStrips}
            />
          </BiLoggerContextProvider>
        ))}
      </OverlayContextProvider>

      {/* TODO: move this out into the page level */}
      {isSearchPage && (
        <MoreDeviationsBySearch
          searchTerm={searchTerm}
          mainContentUrl={mainContentUrl}
        />
      )}
    </div>
  );
};
Strips.displayName = 'Strips';

export default Strips;
